import { useCallback, useMemo } from 'react'
import type { TableHead } from '@winnin/winnin_ui.components.table/dist/table'

import type { ITableItem } from 'components/base-table/base-table.types'
import FormatedTableCell from 'components/FormatedTableCell'
import { RelevanceTableCellLazy } from 'components/TerritoriesTable/RelevanceTableCell'
import { useTranslate } from 'lib/tolgee'
import { TerritoryTitleTableCell } from 'modules/territory'
import { FavoriteTerritoryCell } from 'modules/territory/favorite-territory-cell'
import { TOLGEE_GLOBALS } from 'utils'

import { NicheTableCellSkeleton } from './niche-table.skeleton'
import type { INicheTable } from './niche-table.types'

export const useNicheTableModel = ({ niches, handleTrackClick }: INicheTable) => {
  const t = useTranslate()

  const headers: TableHead[] = useMemo(
    () => [
      {
        label: '',
        key: 'favorite',
        component: FavoriteTerritoryCell,
        isSortable: false,
      },
      {
        label: t(TOLGEE_GLOBALS.topic),
        key: 'name',
        isTitle: true,
        component: TerritoryTitleTableCell,
      },
      {
        label: t(TOLGEE_GLOBALS.relevance),
        key: 'relevance',
        component: RelevanceTableCellLazy,
        isSortable: false,
      },
      {
        label: t(TOLGEE_GLOBALS.engPerVideo),
        key: 'avgEngagement',
        component: props => {
          return (
            <NicheTableCellSkeleton {...props}>
              <FormatedTableCell {...props} />
            </NicheTableCellSkeleton>
          )
        },
        isSortable: true,
      },
      {
        label: t(TOLGEE_GLOBALS.viewsPerVideo),
        key: 'avgViews',
        component: props => {
          return (
            <NicheTableCellSkeleton {...props}>
              <FormatedTableCell {...props} />
            </NicheTableCellSkeleton>
          )
        },
        isSortable: true,
      },
      {
        label: t(TOLGEE_GLOBALS.videos),
        key: 'totalPosts',
        component: props => {
          return (
            <NicheTableCellSkeleton {...props}>
              <FormatedTableCell {...props} />
            </NicheTableCellSkeleton>
          )
        },
        isSortable: true,
      },
    ],
    [t]
  )

  const onRowClick = useCallback(
    (row: ITableItem) => {
      const name = typeof row?.name === 'string' ? row.name : ''
      if (!name) return
      handleTrackClick?.({ name })
    },
    [handleTrackClick]
  )

  return { headers, niches, onRowClick }
}
